export function initHeader(){
    const header = document.querySelector<HTMLElement>('.header');
    const sectionStart = document.querySelector<HTMLElement>('.section-start');
    const footer = document.querySelector<HTMLElement>('footer');

    function checkOverlap() {
        if (!header) return;

        const headerRect = header.getBoundingClientRect();
        const sectionRect = sectionStart?.getBoundingClientRect();
        const footerRect = footer?.getBoundingClientRect();

        // проверяем, не пересекается ли он с section-start или footer
        const overlapsSection =
            sectionRect &&
            headerRect.bottom > sectionRect.top &&
            headerRect.top < sectionRect.bottom;

        const overlapsFooter =
            footerRect &&
            headerRect.bottom > footerRect.top &&
            headerRect.top < footerRect.bottom;

        if (!overlapsSection && !overlapsFooter) {
            header.classList.add('black');
        } else {
            header.classList.remove('black');
        }
    }

    window.addEventListener('scroll', checkOverlap);
    window.addEventListener('resize', checkOverlap);
    checkOverlap();
}